import cloneDeep from 'lodash/cloneDeep';
const AttributeHelpers = (attributes) => {

  const traverseAttributeTree = (attribute,func) => {
    //reached leaf node
    if(!attribute.children?.length){
      func(attribute);
      return;
    }
    attribute.children?.forEach((child)=>{
      traverseAttributeTree(child,func);
    })
  }

  const flatten = () => {
    const flattenAttribute = (attribute) => {
      let result = [];
      result.push(attribute);
      attribute.children.forEach((child) => flattenChild(result, child));
      return result;
    };
    const flattenChild = (result, child) => {
      if (!child) return;
      result.push(child);
      child.children.forEach((child) => flattenChild(child));
    };
    return attributes
      .map((attribute) => flattenAttribute(attribute))
      .reduce((arr, currAttributeArr) => [...arr, ...currAttributeArr], []);
  };

  const map = (func) => {
    const newTree = cloneDeep(attributes);
    newTree.forEach((attr)=>{
      traverseAttributeTree(attr,func)
    })
    return newTree;
  };

  const forEach = (func) => {
    attributes.forEach((attr)=>{
      traverseAttributeTree(attr,func);
    })
  };

  return {
    flatten,
    map,
    forEach
  };
};

export default AttributeHelpers;
